import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Text, Switch } from '../fields'
import { useForm, Controller } from 'react-hook-form'
import './_smsForm.scss'

const SmsForm = ({
  fields = [], 
  onSubmit,  
  disabled = false,
  formRef
}) => {
  const { current: fieldsMap } = useRef({
    text: Text,
    switch: Switch
  })

  const { control, handleSubmit } = useForm({ 
    mode: 'onChange',
    defaultValues: fields.reduce((acc, field) => {
      acc[field.options.name] = field.options.value || '';
      return acc;
    }, {})
  });
  
  useEffect(() => {
    if (formRef) {
      formRef.current = {
        submit: handleSubmit(handleFormSubmit)
      };
    }
  }, [handleSubmit, formRef]);

  const renderField = field => {
    const Field = fieldsMap[field.component];

    if (!Field) {
      console.warn(`Component type "${field.component}" not supported`);
      return null;
    }

    return (
      <Controller
        control={control}
        key={field.options?.name}
        name={field.options?.name}
        rules={{ 
          required: field.validations?.required 
            ? field.validations.required.message 
            : false 
        }}
        render={({
          field: { value, onChange, onBlur },
          fieldState: { error }
        }) => (
          <Field
            onBlur={onBlur}
            onChange={onChange}
            disabled={disabled}
            errorMessage={error?.message}
            {...field.options}
            value={value}
          />
        )}
      />
    )
  }

  const handleFormSubmit = (data) => {
    const parsedData = fields.map(f => ({
      ...f,
      options: {
        ...f.options,
        value: data[f.options.name]
      }
    }));
    onSubmit(parsedData);
  }

  return (
    <form 
      className="custom-form" 
      onSubmit={handleSubmit(handleFormSubmit)}
    >
      <div className="custom-form__fields">
        {fields.map(renderField)}
      </div>
    </form>
  )
}


SmsForm.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  name: PropTypes.string,
  onSubmit: PropTypes.func,
  onValidityChange: PropTypes.func,
  disabled: PropTypes.bool,
  fields: PropTypes.arrayOf(PropTypes.shape({
    component: PropTypes.oneOf(['text', 'switch']),
    options: PropTypes.shape({
      name: PropTypes.string.isRequired,
      placeholder: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
      ])
    }),
    validations: PropTypes.shape({
      required: PropTypes.shape({
        message: PropTypes.string
      })
    })
  }))
}

export default SmsForm